import script from "./TopLeft.vue?vue&type=script&lang=ts"
export * from "./TopLeft.vue?vue&type=script&lang=ts"

import "./TopLeft.vue?vue&type=style&index=0&id=3ae1d3d3&lang=css"

export default script